module.exports = __webpack_public_path__ + "static/media/bed-alt.e012fc5e.svg";